<!-- 打印盘点计划 -->
<template>
	<div>
		<el-dialog :visible.sync="dataActionBox.showStatus" title="盘点计划" :with-header="false" append-to-body center  width="60%" top="2rem">
			<table v-if="dataInfo" class="print_table_one" id="print_table">
				<tr>
					<td>
						单号：{{dataInfo.ipmId}}
					</td>
					<td>
						开始时间：{{$common.getLocalTime(dataInfo.ipmStime)}}
					</td>
					
				</tr>
				<tr>
					<td>
						货主：{{dataInfo.coName}}
					</td>
					<td>
						库房：{{dataInfo.stName}}
					</td>
				</tr>
				<tr>
					<td colspan="2">
						备注：{{dataInfo.ipmRemark}}
					</td>
				</tr>
				<tr >
					<td colspan="2">
						<table class="print_table_two" border="1">
							<tr>
								<td>编号</td>
								<td>名称</td>
								<td>生产厂家</td>
								<td>产地</td>
								<td>规格</td>
								<td>批号</td>
								<td>系统库存</td>
								<td>实盘数量</td>
							</tr>
							<tr v-for="(items,keys) in dataInfo.invplanDetailInfos" :key="keys">
								<td>{{items.bgmCode}}</td>
								<td>{{items.bgmName}}</td>
								<td>{{items.bgmManufacturer}}</td>
								<td>{{items.bgmPlaceorigin}}</td>
								<td>{{items.bgmSpecifications}}</td>
								<td>{{items.ipdBatnumber}}</td>
								<td>{{items.ipdTnumber}}</td>
								<td>{{items.ipdAinumber}}</td>
							</tr>
						</table>
					</td>
				</tr>
			</table>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dataActionBox.showStatus = false">取消</el-button>
				<el-button type="primary" @click="sendDataAction">打印</el-button>
			</div>
		</el-dialog>
	</div>
	
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import printJS  from 'print-js'
export default {
	name:'printingStockLnventoryPlan',
	props:[],
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
			dataActionBox:{
				showStatus:false,
			},
			dataInfo:{}
			
        };
    },
    //监听属性 类似于data概念
    computed: {
	},
    //监控data中的数据变化
    watch: {
	},
    //方法集合
    methods: {
		openBox(oldData=''){
			this.dataInfo = oldData
			this.dataActionBox.showStatus = true
			
		},
		async sendDataAction(){
			  // 此处的style即为打印时的样式
			const style = '@page {  } ' +'@media print { .print_table_one{ width: 100%; } .print_table_two{border-collapse:collapse;border-spacing:0;border-left:1px solid #888;border-top:1px solid #888;width: 100%;} .print_table_two td{padding: 1rem .5rem;text-align: center;}';
		
			printJS({ 
				printable:'print_table', 
				type: 'html',
				header: '库存盘点计划',
				style: style,// 亦可使用引入的外部css;
				scanStyles: false
			})
		},
	
		
		
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() {
	}, //生命周期 - 创建之前
    beforeMount() {
	}, //生命周期 - 挂载之前
    beforeUpdate() {
	}, //生命周期 - 更新之前
    updated() {
	}, //生命周期 - 更新之后
    beforeDestroy() {
	}, //生命周期 - 销毁之前
    destroyed() {
	}, //生命周期 - 销毁完成
    activated() {
	}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style>
	.print_table_one{
		width: 100%;
		
	}
	.print_table_two{
		border-collapse:collapse;
		border-spacing:0;
		border-left:1px solid #888;
		border-top:1px solid #888;
		width: 100%;
	}
	.print_table_two td{
		padding: 1rem .5rem;
		text-align: center;
	}
	/* table{
		border-collapse:collapse;
		border-spacing:0;
		border-left:1px solid #888;
		border-top:1px solid #888;
	}   */
	
	/* th,td{border-right:1px solid #888;border-bottom:1px solid #888;padding:5px 15px;}   */
	
	/* th{font-weight:bold;}   */
</style>
